import { render, staticRenderFns } from "./MediaImageImg70tit30.vue?vue&type=template&id=99bc7926&scoped=true"
import script from "./MediaImageImg70tit30.vue?vue&type=script&lang=js"
export * from "./MediaImageImg70tit30.vue?vue&type=script&lang=js"
import style0 from "./MediaImageImg70tit30.vue?vue&type=style&index=0&id=99bc7926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bc7926",
  null
  
)

export default component.exports